export default __webpack_public_path__ + "static/media/yellow-3.917ec76c.svg";